import { ViewContainerRef } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { LoginService } from '../../core/login/login.service';
import { AccountService } from '../../core/auth/account.service';
import { OfflineMessageService } from '../offline-message/offline-message.service';
import { LANGUAGES } from '../../core/language/language.constants';
import { ViewportScroller } from '@angular/common';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { NavbarInukaService } from './navbar-inuka.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { timer } from "rxjs";
import { TrackerService } from '../../core/tracker/tracker.service';
import { CoachDetailsService } from '../slot/coach-details.service';
import { UserService } from '../../core/user/user.service';
import { OrganizationResourceService } from '../../admin/organization-resource/organization-resource.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/tracker/tracker.service";
import * as i2 from "../../ng-jhipster/service";
import * as i3 from "../../core/auth/account.service";
import * as i4 from "../../core/user/user.service";
import * as i5 from "../../core/login/login.service";
import * as i6 from "@angular/router";
import * as i7 from "../offline-message/offline-message.service";
import * as i8 from "@angular/common";
import * as i9 from "./navbar-inuka.service";
import * as i10 from "../slot/coach-details.service";
import * as i11 from "../../admin/organization-resource/organization-resource.service";
import * as i12 from "../../ng-jhipster/language";
import * as i13 from "@ng-bootstrap/ng-bootstrap";
import * as i14 from "../../shared/util/long-press.directive";
import * as i15 from "../../shared/support/support-dropdown.component";
import * as i16 from "../../shared/language/language-selector/language-selector.component";
import * as i17 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i18 from "../../shared/track-user-activity.directive";
import * as i19 from "../../shared/auth/has-any-authority.directive";
import * as i20 from "../../shared/upload-image-component/profile-image.component";
const _c0 = ["myDrop"];
const _c1 = ["embeddedComponentContainer"];
function NavbarInukaComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "img", 24);
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵtext(3, "powered by inuka");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c2 = function () { return { "track": "click", "name": "ss_booksession_btn_clicked" }; };
function NavbarInukaComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function NavbarInukaComponent_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onBookSession(); });
    i0.ɵɵelement(1, "h5", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(1, _c2));
} }
function NavbarInukaComponent_div_21_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "profile-image", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachId", ctx_r9.currentUser.id)("coachLogin", ctx_r9.currentUser.login)("doUpload", false)("size", 54);
} }
const _c3 = function (a0) { return { "width": a0 }; };
function NavbarInukaComponent_div_21_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34, 35);
    i0.ɵɵlistener("mouseover", function NavbarInukaComponent_div_21_div_5_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.checkOverflow(_r12) ? ctx_r13.showTooltip = true : ctx_r13.showTooltip = false; });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c3, ctx_r10.isCoach ? "200px" : "300px"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.currentUser.email, " ");
} }
function NavbarInukaComponent_div_21_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵlistener("mouseleave", function NavbarInukaComponent_div_21_div_6_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.showTooltip = false; });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(3, 2, ctx_r11.currentUser.email, 0, ctx_r11.currentUser.email.indexOf("@")));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(7, 6, ctx_r11.currentUser.email, ctx_r11.currentUser.email.indexOf("@"), ctx_r11.currentUser.email.length));
} }
const _c4 = function () { return ["ROLE_COACH"]; };
function NavbarInukaComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, NavbarInukaComponent_div_21_div_1_Template, 2, 4, "div", 29);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "h3");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, NavbarInukaComponent_div_21_div_5_Template, 3, 4, "div", 30);
    i0.ɵɵtemplate(6, NavbarInukaComponent_div_21_div_6_Template, 8, 10, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(4, _c4));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.currentUser.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.showTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showTooltip);
} }
function NavbarInukaComponent_div_23_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 40);
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_23_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 41);
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_23_li_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 42);
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_23_li_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 43);
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_23_li_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 44);
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_23_li_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 45);
    i0.ɵɵelementEnd();
} }
const _c5 = function () { return ["ROLE_USER", "ROLE_CUSTOMER_CARE"]; };
const _c6 = function () { return ["ROLE_ORGANIZATION_ADMIN"]; };
function NavbarInukaComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "li");
    i0.ɵɵelement(2, "a", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NavbarInukaComponent_div_23_li_3_Template, 2, 0, "li", 38);
    i0.ɵɵtemplate(4, NavbarInukaComponent_div_23_li_4_Template, 2, 0, "li", 38);
    i0.ɵɵelementStart(5, "li");
    i0.ɵɵelement(6, "a", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, NavbarInukaComponent_div_23_li_7_Template, 2, 0, "li", 38);
    i0.ɵɵtemplate(8, NavbarInukaComponent_div_23_li_8_Template, 2, 0, "li", 38);
    i0.ɵɵtemplate(9, NavbarInukaComponent_div_23_li_9_Template, 2, 0, "li", 21);
    i0.ɵɵtemplate(10, NavbarInukaComponent_div_23_li_10_Template, 2, 0, "li", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("routerLink", ctx_r5.indexRoute);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(8, _c4));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(9, _c5));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("routerLink", ctx_r5.settingsRoute);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(10, _c5));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(11, _c4));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.showResourcesLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(12, _c6));
} }
function NavbarInukaComponent_div_24_li_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 49);
    i0.ɵɵtext(2, "Supervisors");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 50);
    i0.ɵɵtext(2, "Self-Scan Statistics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 51);
    i0.ɵɵtext(2, "Ratings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 52);
    i0.ɵɵtext(2, "Voucher Management");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 53);
    i0.ɵɵtext(2, "Organization Codes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 54);
    i0.ɵɵtext(2, "Organizations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 55);
    i0.ɵɵtext(2, "Packages");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 56);
    i0.ɵɵtext(2, "Payments");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 57);
    i0.ɵɵtext(2, "Organization resources");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 58);
    i0.ɵɵtext(2, "Resources for help");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 59);
    i0.ɵɵtext(2, "Scripts");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 60);
    i0.ɵɵtext(2, "Qualification");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 61);
    i0.ɵɵtext(2, "Video Call Hosts");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 62);
    i0.ɵɵtext(2, "Extra Questions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 63);
    i0.ɵɵtext(2, "User Tracking");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 64);
    i0.ɵɵtext(2, "Audit Log");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 65);
    i0.ɵɵtext(2, "Automated Messages");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 66);
    i0.ɵɵtext(2, "Canned Messages");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 67);
    i0.ɵɵtext(2, "Email feedback");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 68);
    i0.ɵɵtext(2, "Feedback");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 69);
    i0.ɵɵtext(2, "Notification preferences");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 70);
    i0.ɵɵtext(2, "Planning Log");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 71);
    i0.ɵɵtext(2, "Tips");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 72);
    i0.ɵɵtext(2, "Notification preferences");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 73);
    i0.ɵɵtext(2, "Security Policies");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 74);
    i0.ɵɵtext(2, "Planning Setting");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 75);
    i0.ɵɵtext(2, "External Identity Provider");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarInukaComponent_div_24_li_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 45);
    i0.ɵɵelementEnd();
} }
const _c7 = function () { return ["ROLE_MASTERMIND"]; };
const _c8 = function () { return ["ROLE_MASTERMIND", "ROLE_SUPERVISOR"]; };
const _c9 = function () { return ["ROLE_MASTERMIND", "ROLE_ADMIN", "ROLE_SUPERVISOR"]; };
const _c10 = function () { return ["ROLE_MASTERMIND", "ROLE_ADMIN"]; };
const _c11 = function () { return ["ROLE_MASTERMIND", "ROLE_SUPERVISOR", "ROLE_ADMIN"]; };
function NavbarInukaComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "li");
    i0.ɵɵelementStart(2, "a", 46);
    i0.ɵɵtext(3, "Sessions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "li");
    i0.ɵɵelementStart(5, "a", 47);
    i0.ɵɵtext(6, "Users");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵelementStart(8, "a", 48);
    i0.ɵɵtext(9, "Coaches");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, NavbarInukaComponent_div_24_li_10_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(11, NavbarInukaComponent_div_24_li_11_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(12, NavbarInukaComponent_div_24_li_12_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(13, NavbarInukaComponent_div_24_li_13_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(14, NavbarInukaComponent_div_24_li_14_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(15, NavbarInukaComponent_div_24_li_15_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(16, NavbarInukaComponent_div_24_li_16_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(17, NavbarInukaComponent_div_24_li_17_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(18, NavbarInukaComponent_div_24_li_18_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(19, NavbarInukaComponent_div_24_li_19_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(20, NavbarInukaComponent_div_24_li_20_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(21, NavbarInukaComponent_div_24_li_21_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(22, NavbarInukaComponent_div_24_li_22_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(23, NavbarInukaComponent_div_24_li_23_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(24, NavbarInukaComponent_div_24_li_24_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(25, NavbarInukaComponent_div_24_li_25_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(26, NavbarInukaComponent_div_24_li_26_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(27, NavbarInukaComponent_div_24_li_27_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(28, NavbarInukaComponent_div_24_li_28_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(29, NavbarInukaComponent_div_24_li_29_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(30, NavbarInukaComponent_div_24_li_30_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(31, NavbarInukaComponent_div_24_li_31_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(32, NavbarInukaComponent_div_24_li_32_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(33, NavbarInukaComponent_div_24_li_33_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(34, NavbarInukaComponent_div_24_li_34_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(35, NavbarInukaComponent_div_24_li_35_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(36, NavbarInukaComponent_div_24_li_36_Template, 3, 0, "li", 38);
    i0.ɵɵtemplate(37, NavbarInukaComponent_div_24_li_37_Template, 2, 0, "li", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(28, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(29, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(30, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(31, _c9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(32, _c9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(33, _c9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(34, _c10));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(35, _c10));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(36, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(37, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(38, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(39, _c11));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(40, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(41, _c9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(42, _c10));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(43, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(44, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(45, _c11));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(46, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(47, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(48, _c11));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(49, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(50, _c8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(51, _c11));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(52, _c10));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(53, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(54, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(55, _c6));
} }
const _c12 = function (a0) { return { "transform": a0 }; };
export class NavbarInukaComponent {
    constructor(trackerService, eventManager, accountService, userService, loginService, router, messageService, viewportScroller, navbarInukaService, coachDetailsService, organizationResourceService, languageService) {
        this.trackerService = trackerService;
        this.eventManager = eventManager;
        this.accountService = accountService;
        this.userService = userService;
        this.loginService = loginService;
        this.router = router;
        this.messageService = messageService;
        this.viewportScroller = viewportScroller;
        this.navbarInukaService = navbarInukaService;
        this.coachDetailsService = coachDetailsService;
        this.organizationResourceService = organizationResourceService;
        this.languageService = languageService;
        this.unreadMessageCount = 0;
        this.languages = LANGUAGES;
        this.navbarTitle = this.navbarInukaService.navbarTitle;
        this.showTooltip = false;
        this.allowedUrlList = ['/wellbeing-result'];
        this.langKey = this.languageService.getCurrentLanguage() ? this.languageService.getCurrentLanguage() : "en";
    }
    ngAfterViewInit() {
        this.navbarInukaService.registerAsEmbeddedComponentHost(this.embeddedComponentContainerViewRef);
    }
    ngOnInit() {
        this.isUser = this.accountService.hasAnyAuthority(['ROLE_USER']);
        this.isCoach = this.accountService.hasAnyAuthority(['ROLE_COACH']);
        this.isType3 = this.accountService.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_MASTERMIND']);
        this.isAdmin = this.accountService.hasAnyAuthority(['ROLE_ADMIN']);
        this.isSupervisor = this.accountService.hasAnyAuthority(['ROLE_SUPERVISOR']);
        this.isMastermind = this.accountService.hasAnyAuthority(['ROLE_MASTERMIND']);
        this.getCurrentUser();
        this.fetchUnreadMessageCount();
        this.unreadConversationCountSubscription = this.eventManager.subscribe('unreadConversationCount', () => {
            timer(500).subscribe(() => {
                // giving some time to mysql to persist received messages
                // when this request is triggered immediately on my dev server, mysql returns 0
                this.fetchUnreadMessageCount();
            });
        });
        this.preferencesChangedSubscription = this.eventManager.subscribe('preferencesChangedModification', () => {
            this.getCurrentUser();
        });
        this.router.events.subscribe((val) => {
            if (val instanceof RouterEvent) {
                this.showBookSessionButton = this.allowedUrlList.includes(this.router.url);
            }
        });
        this.eventManager.subscribe('langKeyChanged', () => {
            if (this.currentUser != null)
                this.getShowResourcesLink();
        });
        this.subscribeToWebsocket();
    }
    getShowResourcesLink() {
        if (this.accountService.isAuthenticated() && this.accountService.isUser()) {
            this.langKey = this.languageService.getCurrentLanguage() ? this.languageService.getCurrentLanguage() : "en";
            this.organizationResourceService.getOrganizationResourcesByUserIdAndLangkey(this.currentUser.id, this.langKey).subscribe(res2 => {
                this.organizationResources = res2.body || [];
                this.showResourcesLink = this.organizationResources.length > 0;
            });
        }
    }
    getCurrentUser() {
        this.userService.current().subscribe(currentUser => {
            this.currentUser = currentUser;
            console.log(this.currentUser);
            if (this.currentUser)
                this.getShowResourcesLink();
            if (this.currentUser != null) {
                if (this.isUser) {
                    this.indexRoute = '/index-user';
                    this.settingsRoute = '/user-settings';
                }
                else if (this.isCoach) {
                    this.coachDetailsService.findCoachDetails(this.currentUser.id).subscribe(response2 => {
                        this.coachDetails = response2.body;
                        this.hasImage = this.coachDetails.imageUrl != null;
                    });
                    this.indexRoute = '/index-coach';
                    this.settingsRoute = '/coach-settings';
                }
                else if (this.isType3) {
                    this.indexRoute = '/admin/session-management';
                }
                else {
                    console.log("Authority is not recognized.");
                    return;
                }
            }
            else {
                this.indexRoute = '/register-corporate';
            }
        });
    }
    subscribeToWebsocket() {
        this.trackerServiceSubscription = this.trackerService.listenerSubject.subscribe(value => {
            const type = value['type'];
            if (type === 'OFFLINE_MESSAGE_RECEIVED') {
                this.eventManager.broadcast({ name: 'unreadConversationCount', content: {} });
            }
        });
    }
    fetchUnreadMessageCount() {
        console.log("fetchUnreadMessageCount");
        this.messageService.unreadMessageCount().subscribe(res => (this.unreadMessageCount = res.body));
    }
    ngDoCheck() {
        if (this.navbarTitle !== this.navbarInukaService.navbarTitle) {
            this.navbarTitle = this.navbarInukaService.navbarTitle;
        }
    }
    titleText() {
        return 'inukaNgApp.navbar.title.' + this.navbarTitle;
    }
    logout() {
        this.collapseDropdown();
        this.loginService.logout();
        this.router.navigate(['']);
        this.accountService.clearCookies();
    }
    countryIsZimbabwe() {
        return window.userCountry === 'Zimbabwe';
    }
    toggleDropdown(event) {
        console.log(event);
    }
    collapseDropdown() {
        this.myDrop.close();
    }
    scrollToElement(elementId) {
        this.collapseDropdown();
        this.viewportScroller.scrollToAnchor(elementId);
    }
    menuButtonClicked() {
        let url = this.router.routerState.snapshot.url;
        if (url === "/index-user") {
            this.trackerService.sendActivity('home_menu_btn_clicked');
        }
        else if (url === "/wellbeing-result") {
            this.trackerService.sendActivity('ss_results_menu_btn_clicked');
        }
    }
    checkOverflow(element) {
        return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
    }
    onBookSession() {
        this.trackerService.sendActivity("navbar_book_session_clicked");
    }
    ngOnDestroy() {
        if (this.unreadConversationCountSubscription != null)
            this.unreadConversationCountSubscription.unsubscribe();
        if (this.trackerServiceSubscription != null)
            this.trackerServiceSubscription.unsubscribe();
        if (this.preferencesChangedSubscription != null)
            this.preferencesChangedSubscription.unsubscribe();
    }
    toggleConsoleLogViewer() {
        this.eventManager.broadcast('toggleConsoleLogViewer');
    }
}
NavbarInukaComponent.ɵfac = function NavbarInukaComponent_Factory(t) { return new (t || NavbarInukaComponent)(i0.ɵɵdirectiveInject(i1.TrackerService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i3.AccountService), i0.ɵɵdirectiveInject(i4.UserService), i0.ɵɵdirectiveInject(i5.LoginService), i0.ɵɵdirectiveInject(i6.Router), i0.ɵɵdirectiveInject(i7.OfflineMessageService), i0.ɵɵdirectiveInject(i8.ViewportScroller), i0.ɵɵdirectiveInject(i9.NavbarInukaService), i0.ɵɵdirectiveInject(i10.CoachDetailsService), i0.ɵɵdirectiveInject(i11.OrganizationResourceService), i0.ɵɵdirectiveInject(i12.JhiLanguageService)); };
NavbarInukaComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavbarInukaComponent, selectors: [["jhi-navbar-inuka"]], viewQuery: function NavbarInukaComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myDrop = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.embeddedComponentContainerViewRef = _t.first);
    } }, decls: 27, vars: 9, consts: [[1, "olha-theme", 2, "font-size", "1rem"], ["id", "page-navbar", 1, "navbar", "navbar-dark", "d-flex", "align-items-center", 2, "height", "60px"], ["longPress", "", 1, "d-flex", "align-items-center", "left-side-margin", 3, "mouseLongPress"], [3, "routerLink"], [2, "width", "5.2rem!important", "height", "2.2rem!important"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#inuka-logo-left"], [1, "d-none", "d-xl-block", "top-center"], ["embeddedComponentContainer", ""], ["class", "top-center", 4, "ngIf"], [1, "d-flex", "align-items-center", "right-side-margin"], ["routerLink", "/session/schedule-session", "class", "d-none d-md-block d-lg-block d-xl-block btn btn-secondary align-items-center justify-content-center mr-3", 3, "trackUserActivity", "click", 4, "ngIf"], [1, "ml-3", "mr-3"], [1, "ml-3", "mr-3", "d-none", "d-md-block", "d-lg-block", "d-xl-block"], ["ngbDropdown", "", 1, "ml-3", "d-inline-block", "text-dark", "align-middle", 3, "openChange"], ["myDrop", "ngbDropdown"], ["ngbDropdownToggle", "", "id", "navbar-dropdown-button", 1, "navbar-toggler", 3, "click"], ["src", "../../../../content/images/inuka/hamburger-medium.png", "alt", "hamburger-medium image", 1, "navbar-dropdown-hamburger", 2, "transform", "rotate(90deg)", 3, "ngStyle"], ["ngbDropdownMenu", "", 1, "collapse", "dropdown-menu", "dropdown-menu-right", "dropdown-menu-location"], [1, "ml-3", "mr-3", "d-md-none", "language-selector"], ["class", "d-flex justify-content-between align-items-center identification", 4, "ngIf"], [3, "click"], [4, "ngIf"], ["jhiTranslate", "global.menu.logOut", 1, "btn", "btn-secondary", 3, "click"], [1, "top-center"], ["src", "../../../../content/images/inuka/FB-inuka-small.png", "alt", "FB-inuka-small image", 2, "height", "60px"], [1, "align-bottom", 2, "font-size", "12px", "margin-top", "40px!important"], ["routerLink", "/session/schedule-session", 1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "btn", "btn-secondary", "align-items-center", "justify-content-center", "mr-3", 3, "trackUserActivity", "click"], ["jhiTranslate", "wellBeingResult.button.bookASession", 1, "mb-0"], [1, "d-flex", "justify-content-between", "align-items-center", "identification"], ["class", "profile-icon", 4, "jhiHasAnyAuthority"], ["class", "overflow", 3, "ngStyle", "mouseover", 4, "ngIf"], ["class", "overflow-tool-tip", 3, "mouseleave", 4, "ngIf"], [1, "profile-icon"], [3, "coachId", "coachLogin", "doUpload", "size"], [1, "overflow", 3, "ngStyle", "mouseover"], ["overflow", ""], [1, "overflow-tool-tip", 3, "mouseleave"], ["jhiTranslate", "global.menu.home", 3, "routerLink"], [4, "jhiHasAnyAuthority"], ["jhiTranslate", "global.menu.profile", 3, "routerLink"], ["routerLink", "/my-availability", "jhiTranslate", "global.menu.myAvailability"], ["routerLink", "/session/schedule-session", "jhiTranslate", "global.menu.bookSession"], ["routerLink", "/session/inbox/all", "jhiTranslate", "global.menu.customerCare"], ["routerLink", "/my-statistics", "jhiTranslate", "global.menu.myStatistics"], ["routerLink", "/organization-resources", "jhiTranslate", "global.menu.supportResources"], ["routerLink", "/organization-selection", "jhiTranslate", "inukaNgApp.organizationAdmin.organizationAdminNavbar.switchAccount"], ["routerLink", "/admin/session-management", "jhiTranslate", "global.menu.sessions"], ["routerLink", "/admin/user-management", "jhiTranslate", "global.menu.users"], ["routerLink", "/admin/coach-management", "jhiTranslate", "global.menu.coaches"], ["routerLink", "/admin/supervisor-management", "jhiTranslate", "global.menu.supervisors"], ["routerLink", "/admin/test-management", "jhiTranslate", "global.menu.wellbeingTestStatistics"], ["routerLink", "/admin/rating-management", "jhiTranslate", "global.menu.ratings"], ["routerLink", "/admin/voucher-management", "jhiTranslate", "global.menu.voucherManagement"], ["routerLink", "/admin/organization-code-management", "jhiTranslate", "global.menu.organizationCodes"], ["routerLink", "/admin/organization-management", "jhiTranslate", "global.menu.organizations"], ["routerLink", "/pricing", "jhiTranslate", "global.menu.entities.pricing"], ["routerLink", "/admin/payments", "jhiTranslate", "global.menu.payments"], ["routerLink", "/admin/organization-resource", "jhiTranslate", "global.menu.organizationResources"], ["routerLink", "/admin/resource-for-help", "jhiTranslate", "global.menu.resources"], ["routerLink", "/admin/script", "jhiTranslate", "global.menu.scripts"], ["routerLink", "/admin/qualification", "jhiTranslate", "global.menu.qualification"], ["routerLink", "/admin/video-call-hosts-management", "jhiTranslate", "global.menu.videoCallHost"], ["routerLink", "/admin/extra-question", "jhiTranslate", "global.menu.extraQuestion"], ["routerLink", "/admin/tracker"], ["routerLink", "/admin/audit-log-management", "jhiTranslate", "global.menu.auditLogManagement"], ["routerLink", "/admin/automated-message-management", "jhiTranslate", "global.menu.adminAutomatedMessage"], ["routerLink", "/admin/canned-messages", "jhiTranslate", "global.menu.entities.adminCannedMessages"], ["routerLink", "/admin/email-feedbacks", "jhiTranslate", "global.menu.entities.adminEmailFeedback"], ["routerLink", "/admin/feedback", "jhiTranslate", "global.menu.entities.adminFeedback"], ["routerLink", "/notification-preference-admin", "jhiTranslate", "global.menu.entities.notificationPreferences"], ["routerLink", "/admin/planning-log", "jhiTranslate", "global.menu.entities.planningLog"], ["routerLink", "/admin/tip", "jhiTranslate", "global.menu.entities.tip"], ["routerLink", "/coach-availability-preference", "jhiTranslate", "global.menu.entities.adminCoachAvailabilityPreference"], ["routerLink", "/admin/security-policy", "jhiTranslate", "global.menu.entities.securityPolicy"], ["routerLink", "/admin/planning-setting", "jhiTranslate", "global.menu.entities.planningSetting"], ["routerLink", "/admin/external-identity-provider", "jhiTranslate", "global.menu.entities.externalIdentityProvider"]], template: function NavbarInukaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "nav", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("mouseLongPress", function NavbarInukaComponent_Template_div_mouseLongPress_2_listener() { return ctx.toggleConsoleLogViewer(); });
        i0.ɵɵelementStart(3, "a", 3);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(4, "svg", 4);
        i0.ɵɵelement(5, "use", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementContainer(7, null, 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, NavbarInukaComponent_div_9_Template, 4, 0, "div", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵtemplate(11, NavbarInukaComponent_button_11_Template, 2, 2, "button", 10);
        i0.ɵɵelement(12, "support-dropdown", 11);
        i0.ɵɵelement(13, "language-selector", 12);
        i0.ɵɵelementStart(14, "div", 13, 14);
        i0.ɵɵlistener("openChange", function NavbarInukaComponent_Template_div_openChange_14_listener($event) { return ctx.toggleDropdown($event); });
        i0.ɵɵelementStart(16, "div");
        i0.ɵɵelementStart(17, "button", 15);
        i0.ɵɵlistener("click", function NavbarInukaComponent_Template_button_click_17_listener() { return ctx.menuButtonClicked(); });
        i0.ɵɵelement(18, "img", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "ul", 17);
        i0.ɵɵelement(20, "language-selector", 18);
        i0.ɵɵtemplate(21, NavbarInukaComponent_div_21_Template, 7, 5, "div", 19);
        i0.ɵɵelementStart(22, "div", 20);
        i0.ɵɵlistener("click", function NavbarInukaComponent_Template_div_click_22_listener() { return ctx.collapseDropdown(); });
        i0.ɵɵtemplate(23, NavbarInukaComponent_div_23_Template, 11, 13, "div", 21);
        i0.ɵɵtemplate(24, NavbarInukaComponent_div_24_Template, 38, 56, "div", 21);
        i0.ɵɵelementStart(25, "li");
        i0.ɵɵelementStart(26, "button", 22);
        i0.ɵɵlistener("click", function NavbarInukaComponent_Template_button_click_26_listener() { return ctx.logout(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(15);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("routerLink", ctx.indexRoute);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.countryIsZimbabwe());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showBookSessionButton);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c12, _r3.isOpen() ? "rotate(90deg)" : "rotate(0deg)"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.currentUser != null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isType3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isType3);
    } }, directives: [i13.NgbNavbar, i14.LongPressDirective, i6.RouterLinkWithHref, i8.NgIf, i15.SupportDropdownComponent, i16.LanguageSelectorComponent, i13.NgbDropdown, i13.NgbDropdownToggle, i8.NgStyle, i13.NgbDropdownMenu, i17.JhiTranslateDirective, i6.RouterLink, i18.TrackUserActivityDirective, i19.HasAnyAuthorityDirective, i20.ProfileImageComponent], pipes: [i8.SlicePipe], styles: ["html[_ngcontent-%COMP%]{scroll-behavior:smooth}.badge-rounded-purple-text[_ngcontent-%COMP%]{position:absolute;width:100%;text-align:center}.badge-rounded-purple[_ngcontent-%COMP%]{position:relative;border-radius:50%;height:1.5rem;width:1.5rem;background-color:#9e6a8f;color:#fff;font-size:medium;font-weight:700;text-align:center;text-decoration:none;white-space:nowrap;transition:color .15s ease-in-out}.navbar-toggler[_ngcontent-%COMP%], .navbar-dropdown-hamburger[_ngcontent-%COMP%]{padding:0 !important;transition:all .3s}#navbarToggleExternalContent[_ngcontent-%COMP%]{background-color:#fff !important;z-index:500;margin-top:60px}.navbar-dropdown-list[_ngcontent-%COMP%]{font-weight:bold;font-size:20px;text-align:center}.navbar-dropdown-list[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-bottom:5px}.navbar-dropdown-list[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000 !important;text-decoration:none;text-transform:uppercase}.dropdown-menu[_ngcontent-%COMP%]{background:#f8f7f2;width:360px;padding:70px 5px 70px 70px;height:100%;border:none;box-shadow:-3px 0px 30px rgba(0,0,0,.15)}.dropdown-menu-location[_ngcontent-%COMP%]{position:fixed;top:58px !important;right:0;overflow:scroll}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none !important}.overflow[_ngcontent-%COMP%]{text-overflow:ellipsis;-ms-text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.overflow-tool-tip[_ngcontent-%COMP%]{width:200px}.hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.5rem}h3[_ngcontent-%COMP%]{margin-bottom:0}.identification[_ngcontent-%COMP%]{margin-bottom:40px}.first-letter[_ngcontent-%COMP%]{font-size:40px;font-weight:900 !important;color:#44a38b}.language-selector[_ngcontent-%COMP%]{position:fixed;top:90px;right:20px}li[_ngcontent-%COMP%]{margin-bottom:30px;font-weight:bold}.left-side-margin[_ngcontent-%COMP%]{margin-left:20px !important}.right-side-margin[_ngcontent-%COMP%]{margin-right:20px !important}#page-navbar[_ngcontent-%COMP%]{box-shadow:none;background:#f7f4eb}.profile-icon[_ngcontent-%COMP%]{margin-right:10px}@media(min-width: 576px){.badge-rounded-purple[_ngcontent-%COMP%], .hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.6rem}.language-selector[_ngcontent-%COMP%]{font-size:.9rem}}@media(min-width: 768px){.badge-rounded-purple[_ngcontent-%COMP%], .hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.7rem}.language-selector[_ngcontent-%COMP%]{font-size:1rem}.left-side-margin[_ngcontent-%COMP%]{margin-left:84px !important}.right-side-margin[_ngcontent-%COMP%]{margin-right:84px !important}}@media(min-width: 992px){.badge-rounded-purple[_ngcontent-%COMP%], .hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.8rem}.language-selector[_ngcontent-%COMP%]{font-size:1.1rem}}"] });
